module.exports = __webpack_public_path__ + "static/media/la-regular-400.55c57a74.svg";